import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useActions } from 'shared/customHooks'
import { submitForm } from 'LiveBoard/modules/cta'
import { handleGatingFormSubmit } from 'LiveBoard/modules/gatingForm'
import { onGatingSuccess } from 'LiveBoard/modules/campaign'
import ConfigurableForm from './ConfigurableForm'
import { SuccessMessage } from 'LiveBoard/components/shared/SuccessMessage'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'
import { FORM_CTA_TYPES } from 'LiveBoard/components/shared/CallToAction/types/forms/constants'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const ConfigurableFormPresenter = (props) => {
  const themeColor = useSelector(state => state.campaign.themeColorHex)
  const isGatingCampaign = useSelector(state => state.campaign.isGating)
  const [successMessageConfig, setSuccessMessageConfig] = useState({})

  const actions = useActions({
    submitForm,
    handleGatingFormSubmit,
    onGatingSuccess
  }, [])

  const isGatingForm = props.area === CTA_AREAS.gating
  const isRegistrationForm = props.config.type === FORM_CTA_TYPES.registration
  const isGatingEvent = isGatingCampaign && isRegistrationForm

  const handleOnSubmit = (formData, formFields, successMessage, redirectUrl) => {
    isGatingForm && actions.handleGatingFormSubmit()

    actions.submitForm(formData, formFields)
      .then(() => handlePostSubmit({
        successMessage,
        redirectUrl
      })
      )
      .then(setTimeout(props.onDone, 3000))
  }

  const handlePostSubmit = (postSubmitData) => {
    isGatingEvent ? handleGatingSubmit(postSubmitData) : handleDefaultSubmit(postSubmitData)
  }

  const handleDefaultSubmit = ({ successMessage, redirectUrl }) => {
    setSuccessMessageConfig({ successMessage })

    if (redirectUrl) {
      setTimeout(() => window.location.assign(redirectUrl), 2000)
    }
  }

  const handleGatingSubmit = ({ successMessage }) => {
    actions.onGatingSuccess(successMessage)
  }

  return (
    <div className="configurable-form-presenter-container" style={{ borderColor: themeColor }}>
      { !isEmpty(successMessageConfig)
        ? <SuccessMessage successMessage={successMessageConfig.successMessage} />
        : <ConfigurableForm
            config={props.config}
            area={props.area}
            onDone={props.onDone}
            itemId={props.itemId}
            ctaClass={props.ctaClass}
            form={props.form}
            onSubmit={handleOnSubmit}
            themeColorHex={props.themeColorHex} />
      }
    </div>
  )
}

ConfigurableFormPresenter.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  form: PropTypes.string,
  themeColorHex: PropTypes.string.isRequired
}

ConfigurableFormPresenter.defaultProps = {
  onDone: () => {}
}

export default ConfigurableFormPresenter
